import { Box, Button, Flex, type FlexProps, Text } from '@chakra-ui/react'
import { SampleNote as SampleNoteIcon } from '@components/icons'
import { SampleButton } from '@handlers/signup-v2/components/sample-note-button-shared'
import { useSampleSessions } from '@hooks'
import React from 'react'

interface SampleSessionsModuleProps {
  containerProps?: FlexProps
}

interface SampleNote {
  label: string
  identifier: string
}

export const SampleSessionsModule: React.FC<SampleSessionsModuleProps> = ({
  containerProps = {}
}) => {
  const { sampleNotes } = useSampleSessions()

  return (
    <Flex alignItems="left" direction="column" width="100%" {...containerProps}>
      <Text fontWeight="bold" mb="xsmall" align="left">
        Explore sample notes
      </Text>
      <Box>
        <Flex
          flexDirection="row"
          gap="8px"
          flexWrap="wrap"
          justifyContent="left"
          mb="large"
        >
          {sampleNotes.map(({ label, identifier }: SampleNote) => (
            <SampleButton key={identifier} title={label} type={identifier} />
          ))}
        </Flex>
      </Box>
    </Flex>
  )
}
